module.exports = __webpack_public_path__ + "img/tiaoxin.d0155745.svg";